module.exports = __webpack_public_path__ + "img/diners.01e7bd96.svg";